import { render, staticRenderFns } from "./FacLoginPage.vue?vue&type=template&id=72eac770&scoped=true"
import script from "./FacLoginPage.vue?vue&type=script&lang=js"
export * from "./FacLoginPage.vue?vue&type=script&lang=js"
import style0 from "./FacLoginPage.vue?vue&type=style&index=0&id=72eac770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72eac770",
  null
  
)

export default component.exports